import { proxy } from 'valtio'
import type { PacketData } from '../ReplayPanel'
import { appQueryParams, updateQsParam } from '../../appParams'
import type { ReplayEvent } from '../../packetsReplay/extractReplayEvents'

export const packetsReplayState = proxy({
  packetsPlayback: [] as PacketData[],
  isOpen: false,
  isMinimized: false,
  isRecording: false,
  replayMinecraftVersion: '',
  replayName: '',
  isPlaying: false,
  showPacketList: false,
  // Mirrors TelemetryPanel's local collapsed flag so other HUD
  // components (e.g. TopMenu) can mirror the same animated state.
  telemetryCollapsed: false,
  // Mirrors InfoViewPanel's local collapsed flag so TopMenu can
  // follow InfoViewPanel's right edge when it slides off-screen.
  infoViewCollapsed: false,
  // Mirrors Chat's collapsed flag so TopMenu "hide UI" handles it
  // alongside info, telemetry and the bottom timeline.
  chatCollapsed: false,
  // Mirrors PlayerBottomBar's local collapsed (minimized) flag so the
  // TopMenu "hide UI" control can minimize the timeline alongside the panels.
  bottomBarCollapsed: false,
  seekTo: null as number | null,
  internalRewindTo: null as number | null,
  replayEvents: [] as ReplayEvent[],
  totalTimeMs: 0,
  packetTimesMs: [] as number[],
  progress: {
    current: 0,
    total: 0
  },
  speed: appQueryParams.replaySpeed ? parseFloat(appQueryParams.replaySpeed) : 1,
  customButtons: {
    validateClientPackets: {
      state: appQueryParams.replayValidateClient === 'true',
      label: 'C',
      tooltip: 'Validate client packets'
    },
    stopOnError: {
      state: appQueryParams.replayStopOnError === 'true',
      label: 'E',
      tooltip: 'Stop the replay when an error occurs'
    },
    skipMissingOnTimeout: {
      state: appQueryParams.replaySkipMissingOnTimeout === 'true',
      label: 'T',
      tooltip: 'Skip missing packets on timeout'
    },
    packetsSenderDelay: {
      state: appQueryParams.replayPacketsSenderDelay === 'true',
      label: 'D',
      tooltip: 'Send packets with an additional delay'
    }
  }
})

export const onChangeButtonState = (button: keyof typeof packetsReplayState.customButtons, state: boolean) => {
  packetsReplayState.customButtons[button].state = state
  switch (button) {
    case 'validateClientPackets': {
      updateQsParam('replayValidateClient', String(state))
      break
    }
    case 'stopOnError': {
      updateQsParam('replayStopOnError', String(state))
      break
    }
    case 'skipMissingOnTimeout': {
      updateQsParam('replaySkipMissingOnTimeout', String(state))
      break
    }
    case 'packetsSenderDelay': {
      updateQsParam('replayPacketsSenderDelay', String(state))
      break
    }
  }
}
